
import PinInput from "app/common/components/PinInput";
import useValidation from "app/common/custom-hooks/useValidation";
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import SVG from "react-inlinesvg";
import { forgotPassword } from "app/redux/auth/authHandler";
import { Fade } from "@successtar/react-reveal";
import { update } from "app/common/util/Helpers";

const Step2 = ({email, setStepsData, isLoading}) => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const {validation, data} = useValidation(formRef);
    const otp = Object.values(data).join("");

    useEffect(_ => {
        if (validation.allValid && !!otp){
            update(setStepsData, {otp, step: 3});
        }
    }, [dispatch, setStepsData, validation.allValid, otp])
    
    return  <div>
                <form ref={formRef}>
                    <h2
                        className="text-xl md:text-xl font-semibold pb-3 dark:text-white"
                    >
                        Check your email for a code
                    </h2>
                    <p
                        className=" text-grey-7 text-base"
                    >
                        We've sent a 6-digit code to {email?.[0]}*****{email.substr(-8)}, the  code expires in 10 minutes, please enter it soon. 
                    </p>
                    <div className="py-5 sm:py-8">
                        <div>
                            <PinInput checking={isLoading} />
                        </div>
                        <Fade
                            when={isLoading}
                        >
                            <p className="text-grey-6 text-xs py-3">
                                <SVG
                                    src="/assets/media/svg/checking.svg"
                                    className="inline-block fill-current w-4 mr-1"
                                />
                                Checking...
                            </p>
                        </Fade>
                        <Fade
                            when={!isLoading}
                            bottom
                        >
                            <p className="text-sm pb-3">
                                Didn't get the code? <button className="text-primary" onClick={_ => {dispatch(forgotPassword(email))}}>Resend code</button>
                            </p>
                        </Fade>
                    </div>
                </form>
            </div>
}

export default Step2;